"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPenguinoError = exports.isInputError = exports.isTypeError = exports.isArgumentError = exports.isInvalidArgumentError = exports.isFunctionError = exports.isParseError = exports.isSyntaxError = void 0;
const parser_1 = require("../language/parser");
const scanner_1 = require("../language/scanner");
const error_1 = require("../library/error");
const isSyntaxError = (error) => error instanceof scanner_1.SyntaxError;
exports.isSyntaxError = isSyntaxError;
const isParseError = (error) => error instanceof parser_1.ParseError;
exports.isParseError = isParseError;
const isFunctionError = (error) => error instanceof error_1.InvalidFunctionError;
exports.isFunctionError = isFunctionError;
const isInvalidArgumentError = (error) => error instanceof error_1.InvalidArgumentError;
exports.isInvalidArgumentError = isInvalidArgumentError;
const isArgumentError = (error) => error instanceof error_1.ArgumentError;
exports.isArgumentError = isArgumentError;
const isTypeError = (error) => error instanceof error_1.TypeError;
exports.isTypeError = isTypeError;
const isInputError = (error) => error instanceof error_1.InputError;
exports.isInputError = isInputError;
const isPenguinoError = (error) => (0, exports.isSyntaxError)(error) ||
    (0, exports.isParseError)(error) ||
    (0, exports.isFunctionError)(error) ||
    (0, exports.isArgumentError)(error) ||
    (0, exports.isTypeError)(error) ||
    (0, exports.isInputError)(error);
exports.isPenguinoError = isPenguinoError;
//# sourceMappingURL=error.js.map